import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { CategoryModel } from '../../../../providers/categories/categories';

/**
 * Generated class for the MeSettingsSportartsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-me-settings-sportarts',
  templateUrl: 'me-settings-sportarts.html'
})
export class MeSettingsSportartsPage {
  categories: CategoryModel[];
  picked: CategoryModel[];

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController) {
    this.categories = navParams.data.data.categories;
    this.picked = navParams.data.data.picked;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MeSettingsSportartsPage');
  }

  public categoryCheck(category: CategoryModel): boolean {
    return this.picked.find(x => x.id === category.id) ? true : false;
  }

  getSelected(category: CategoryModel) {
    console.log();
    return this.categoryCheck(category);
  }

  select(category: CategoryModel) {
    if (this.categoryCheck(category)) {
      let index = this.picked.findIndex(x => x.id === category.id);
      this.picked.splice(index, 1);
    } else {
      this.picked.push(category);
    }
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// /src/pages/me/settings/me-settings-sportarts/me-settings-sportarts.ts